import { render } from "./ReceiptShow.vue?vue&type=template&id=e2e22b66&scoped=true"
import script from "./ReceiptShow.vue?vue&type=script&lang=js"
export * from "./ReceiptShow.vue?vue&type=script&lang=js"

import "./ReceiptShow.vue?vue&type=style&index=0&id=e2e22b66&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2e22b66"]])

export default __exports__